/**
 * GlobalDialog Component
 * Global dialog component for the root layout.
 * Renders the active dialog from dialogStore (Zustand).
 */

import React from 'react';
import { Dialog } from './Dialog';

export const GlobalDialog: React.FC = () => {
  return <Dialog />;
};

